import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {Profile} from '@model/profile';
import {School} from '@model/school';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';

import {MatIconModule} from '@angular/material/icon';
import {MatToolbarModule} from '@angular/material/toolbar';

@Component({
    selector: 'horizon-app-toolbar',
    templateUrl: './horizon-app-toolbar.component.html',
    styleUrls: ['./horizon-app-toolbar.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatToolbarModule, MatIconModule, MatButtonModule, MatMenuModule]
})
export class HorizonAppToolbarComponent {

  @Output() openMenuEvent = new EventEmitter();
  @Output() logoutEvent = new EventEmitter();
  @Output() changeProfileEvent = new EventEmitter();
  @Output() goToHelpEvent = new EventEmitter();
  @Output() goToAboutEvent = new EventEmitter();
  @Output() goToGoogleEvent = new EventEmitter<string>();
  @Output() goToOffice365Event = new EventEmitter();

  @Input() selectedProfile: Profile;
  @Input() profiles: Profile[];
  @Input() isMobile: boolean;
  @Input() school: School;

  constructor() { }


  get userName(): string {
    if (this.selectedProfile) {
      return `${this.selectedProfile.firstName} ${this.selectedProfile.lastName}`;
    }
    return '';
  }

  openMenu() {
    this.openMenuEvent.emit();
  }

  changeProfile() {
    this.changeProfileEvent.emit();
  }

  logout() {
    this.logoutEvent.emit();
  }

  goToHelp() {
    this.goToHelpEvent.emit();
  }

  about() {
    this.goToAboutEvent.emit();
  }

  goToGoogle(appName: string) {
    this.goToGoogleEvent.emit(appName);
  }

  goToOffice365() {
    this.goToOffice365Event.emit();
  }

  goToItSchool() {
    window.location.href = this.school.itSchoolLink;
  }
}
